import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import informationIcon from '../../icons/non-prefilled/16x16/information.svg';
import Link from '../../utils/router/Link';
import * as styles from './AnnotationLink.module.scss';
import TruncatedText from './TruncatedText';

interface AnnotationLinkProps {
  link: string;
  text: string;
}

const AnnotationLink = ({ link, text }: AnnotationLinkProps) => {
  const shortenedLink = link.replace(/^https?:\/\/(www\.)?/, '');

  return (
    <div className={styles.container}>
      <SVGIcon size={14} className={styles.icon}>
        {informationIcon}
      </SVGIcon>
      <Link to={link} className={styles.link} newTab>
        {text ? (
          <span className={styles.linkText}>{text}</span>
        ) : (
          <TruncatedText keepLast={8}>{shortenedLink}</TruncatedText>
        )}
      </Link>
    </div>
  );
};

export default AnnotationLink;
